import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

let setVisible = null;

export function showOverlay() {
    if (setVisible) setVisible(true);
}

export function hideOverlay() {
    if (setVisible) setVisible(false);
}

export function OverlayContainer() {
    const [visible, setVisibleState] = useState(false);

    useEffect(() => {
        setVisible = setVisibleState;
        return () => { setVisible = null; };
    }, []);

    if (!visible) return null;

    return ReactDOM.createPortal(
        <div className="resume-preloader__overlay">
            <div className="resume-preloader__spinner" />
        </div>,
        document.body
    );
}
